import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faChevronDown,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import PopoverButton from '../PopoverButton/index.vue'
import { currencyFormat } from '@/helpers/currency-format'

library.add(faTrashAlt, faClose, faChevronDown, faLink)

@Component({
	components: {
		PopoverButton,
	},
})
export default class CJcp extends Vue {
	@Prop({ default: '#aaa', type: String }) color!: string
	@Prop({ required: true, type: String }) id!: string
	@Prop({ required: true, type: Number }) infoId!: number

	advanced = {
		selic: 1.25,
		aliquotPJ: 0.34,
		aliquotPF: 0.15,
	}

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
	}

	years = [
		{
			text: '2015',
			jcp: '0',
			companySavings: '0',
			individualSavings: '0',
			balance: '0',
		},
		{
			text: '2016',
			jcp: '0',
			companySavings: '0',
			individualSavings: '0',
			balance: '0',
		},
		{
			text: '2017',
			jcp: '0',
			companySavings: '0',
			individualSavings: '0',
			balance: '0',
		},
		{
			text: '2018',
			jcp: '0',
			companySavings: '0',
			individualSavings: '0',
			balance: '0',
		},
		{
			text: '2019',
			jcp: '0',
			companySavings: '0',
			individualSavings: '0',
			balance: '0',
		},
		{
			text: '2020',
			jcp: '0',
			companySavings: '0',
			individualSavings: '0',
			balance: '0',
		},
		{
			text: '2021',
			jcp: '0',
			companySavings: '0',
			individualSavings: '0',
			balance: '0',
		},
		{
			text: '2022',
			jcp: '0',
			companySavings: '0',
			individualSavings: '0',
			balance: '0',
		},
	]

	updateSavings(item) {
		const jcpInt = parseFloat(
			item.jcp.replaceAll('.', '').replaceAll(',', '.'),
		)

		const companySavingsInt = this.advanced.aliquotPJ * jcpInt
		item.companySavings = currencyFormat(this.parse(companySavingsInt))

		const individualSavingsInt = this.advanced.aliquotPF * jcpInt
		item.individualSavings = currencyFormat(
			this.parse(individualSavingsInt),
		)

		item.balance = currencyFormat(
			this.parse(companySavingsInt - individualSavingsInt),
		)
	}

	get totalBalance() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(
					item.balance.replaceAll('.', '').replaceAll(',', '.'),
				)
			)
		}, 0)

		this.$emit('savings', total)
		this.$emit('recuperate', total)

		return currencyFormat(total)
	}

	get totalJcp() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(item.jcp.replaceAll('.', '').replaceAll(',', '.'))
			)
		}, 0)

		return currencyFormat(total)
	}

	get totalCompanySavings() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(
					item.companySavings
						.replaceAll('.', '')
						.replaceAll(',', '.'),
				)
			)
		}, 0)

		return currencyFormat(total)
	}

	get totalIndividualSavings() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(
					item.individualSavings
						.replaceAll('.', '')
						.replaceAll(',', '.'),
				)
			)
		}, 0)

		return currencyFormat(total)
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	parse(n) {
		if (isNaN(n)) return 0
		n = parseFloat(n)
		return parseFloat(n.toFixed(2))
	}

	save() {
		this.savePrint()
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.years = this.years
			found.selic = this.advanced.selic
			found.aliquotPF = this.advanced.aliquotPF
			found.aliquotPJ = this.advanced.aliquotPJ
		} else {
			this.calcsEach.unshift({
				id: this.id,
				years: this.years,
				selic: this.advanced.selic,
				aliquotPF: this.advanced.aliquotPF,
				aliquotPJ: this.advanced.aliquotPJ,
			})
		}
	}

	savePrint() {
		const found = this.calcsPrint.find((item) => this.id === item.id)

		const rows = () => {
			return [
				[
					{
						label: 'JCP Total',
						value: 'R$ ' + this.totalJcp,
					},
					{
						label: 'Economia Empresa Total',
						value: 'R$ ' + this.totalCompanySavings,
					},
				],
				[
					{
						label: 'Retenção PF Total',
						value: 'R$ ' + this.totalIndividualSavings,
					},
					{
						label: 'Economia Líquida Total',
						value: 'R$ ' + this.totalBalance,
					},
				],
			]
		}

		if (found) {
			found.rows = rows()
			found.recuperate = this.totalBalance
		} else {
			this.calcsPrint.unshift({
				id: this.id,
				title: 'JCP retroativo - Dedução da base do IRPJ e da CSLL',
				color: this.color,
				columns: 2,
				rows: rows(),
				type: 'table',
				savings: '0',
				recuperate: this.totalBalance,
			})
		}
	}

	created() {
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			this.years = found.years
			this.advanced.selic = found.selic
			this.advanced.aliquotPF = found.aliquotPF
			this.advanced.aliquotPJ = found.aliquotPJ
		}
	}
}
